import styled from 'styled-components';
import { layout } from '../../../package.json';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px;
  img {
    width: 240px;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  /* animation: appearFronRight 1s; */

    svg {
      margin-right: 16px;
      max-height: 300px;
    }
  }
`;

export const Title = styled.h1`
  margin-top: 30px;
  font-size: 28px;
  color: var(--primary);
  text-align: center;

  
  @media (max-width: ${layout.mobile}) {
    font-size: 22px;
  }
`

export const SubTitle = styled.section`
  display: flex;
  flex-direction: column;
  align-items: left;
  font-size: 16px;
  span {
    font-weight: bold;
    color: var(--primary);
  }

  span + span {
    font-size: 12px;
    color: var(--gray);
  }
`
